import AccessTimeOutlinedIcon from '@mui/icons-material/AccessTimeOutlined'
import Router from 'next/router'
import { useSession } from 'next-auth/react'

import { useAppSelector } from '#/app/store/store'
import { accountApi } from '#/shared/api/account-endpoints'
import { useShowDataStore } from '#/shared/lib/hooks/use-show-data'

import styles from './subscription-days-badge.module.scss'

interface SubscriptionDaysBadgeProps {
	days: number
	isInfoBar?: boolean
}

function declineDays(days: number): string {
	const abs = Math.abs(days) % 100
	const last = abs % 10

	if (abs > 10 && abs < 20) return 'дней'
	if (last > 1 && last < 5) return 'дня'
	if (last === 1) return 'день'
	return 'дней'
}

export const SubscriptionDaysBadge = ({ days, isInfoBar = false }: SubscriptionDaysBadgeProps) => {
	const normalizedDays = Number.isFinite(days) ? Math.max(0, Math.trunc(days)) : 0
	const isExpiring = normalizedDays <= 3
	const currentPlanUid = useAppSelector((state) => state.user.payment_plan.plan.uid)
	const { data } = useSession()
	const { showMessage } = useShowDataStore()

	const prefix = isInfoBar ? 'Подписка закончится' : 'Закончится'

	const label =
		normalizedDays <= 1
			? normalizedDays === 0
				? `${prefix} сегодня`
				: `${prefix} завтра`
			: `${prefix} через ${normalizedDays} ${declineDays(normalizedDays)}`

	const handleRenew = async () => {
		if (!data?.access || !currentPlanUid) {
			showMessage('Произошла ошибка при оплате')
			return
		}
		try {
			const urlForPay = await accountApi.payProduct(data.access, currentPlanUid)
			if (urlForPay) {
				await Router.push(urlForPay)
			}
		} catch (err: any) {
			const detail = err?.response?.data?.detail
			const message = detail ?? 'Произошла ошибка при оплате'
			showMessage(message)
		}
	}

	return (
		<button
			type="button"
			className={[
				styles.badge,
				isExpiring ? styles.badge_expiring : '',
			].filter(Boolean).join(' ')}
			onClick={isExpiring ? handleRenew : undefined}
			disabled={!isExpiring}
		>
			<AccessTimeOutlinedIcon className={styles.icon} />
			<span className={styles.text}>
				<span className={styles.textDefault}>
					{normalizedDays <= 1 ? (
						label
					) : (
						<>
							{prefix} через{' '}
							<b className={styles.text_highlight}>
								{normalizedDays} {declineDays(normalizedDays)}
							</b>
						</>
					)}
				</span>
				{isExpiring ? <span className={styles.textHover}>Продлить</span> : null}
			</span>
		</button>
	)
}

